import { BaseModel } from '../../_base/crud';

export class Picking extends BaseModel {
	id: number;
	campaignNumber: string;
	creationDate: string;
	userName: string;
	firstName: string;
	lastName: string;
	orderEventOriginType: string;
	orderEventTypeId: number;
	orderEventStatus: string;
	orderId: number;
	orderEventItems: any[];
	applicationUserId: any;
	orderEventTrackings: any[];
    replacementItems: any[];
    orderEventProducts: any;
    orderEventResultId: any;
}
